import { GetStarted } from "../../components";

export const GetStartedPage = () => {
  // Todo: will add the connection callback handler when AIRs are implemented
  return <GetStarted />;
};
